/* eslint no-console: 0, no-unused-vars: 0, no-undef: 0 */
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import Sentry from '~/util/sentry'
import Vuetify from 'vuetify'
import axios from '~/util/axios'
import '~/assets/css/prefix.scss'
import Snac from '~/util/snac'

import Login from '../components/login/login.vue'

Vue.use(Vuetify)
Vue.use(Snac)

Vue.prototype.$sentry = Sentry([{ key: 'pack', value: 'Login' }])
Vue.prototype.$axios = axios

const app = new Vue({
  el: '#app-container',
  render: h => h('v-app', [h(Login)])
})
